var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogo = function SvgLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 250 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.022.078H0v27.174h19.022l2.717-2.717V2.795L19.022.079zM16.304 20.73l-1.087 1.087H5.435V5.513h9.782L16.304 6.6v14.13zM29.891.078l-2.717 2.718v24.456h19.022l2.717-2.717V.078H29.891zM43.478 20.73l-1.087 1.087H32.61V6.6l1.087-1.087h9.782V20.73z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.397 27.252h-19.05V2.768l2.691-2.69h16.359l2.69 2.69v8.18h-5.435V5.513h-10.87v16.304h10.87v-5.434h5.435v8.179l-2.69 2.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.522 27.252V2.796L84.239.078h2.718v21.74h9.782l1.087-1.088V2.796l2.717-2.718h2.718v24.457l-2.718 2.717H81.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.565.078h-5.435v5.435h5.435V.078zm0 21.74h-5.435v5.434h5.435v-5.435zm-5.435-10.87h5.435v5.434h-5.435v-5.434z",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.891.078l-2.717 2.718v24.456h19.022l2.717-2.717V.078h-19.022zm13.587 20.652l-1.087 1.087h-9.782V6.6l1.087-1.087h9.782V20.73z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.853 27.252h-19.049V2.768l2.691-2.69h16.358l2.691 2.69v8.18h-5.435V5.513h-10.87v16.304h10.87v-5.434h5.435v8.179l-2.691 2.69zM146.739 5.513V.078h-16.304v27.174h5.435v-10.87h8.152v-5.434h-8.152V5.513h10.869zM250 5.513V.078h-19.022v27.174H250v-5.435h-13.587v-5.434h8.152v-5.435h-8.152V5.513H250zM201.087 27.252l-6.739-8.424 4.022-4.049V4.4l-4.321-4.32h-14.701v27.173h5.435V19.1h2.038l6.114 8.152h8.152zm-16.304-21.74h7.038l1.114 1.115v5.897l-1.114 1.114h-7.038V5.513z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .078)",
    d: "M0 0h250v27.174H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo.76060de568578cc3d4aeb96ee07434ea.svg";